
import Typography from '@mui/material/Typography';


export const TextDrugAmitriptyline = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Amitriptyline is used to treat symptoms of depression. Amitriptyline is in a class of medications called tricyclic antidepressants. 
It works by increasing the amounts of certain natural substances in the brain that are needed to maintain mental balance.

<br /><br />
Amitriptyline comes as a tablet to take by mouth. It is usually taken one to four times a day. 

<br /><br />
Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a682388.html<br />
https://files.cpicpgx.org/data/guideline/publication/allopurinol/2015/26094938-supplement.pdf

</Typography>

</div>

)
}